import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const userTagSlice = createSlice({
  name: "userTagData",
  initialState: {},
  reducers: {
    setUserTagLoading: (state: any, action: PayloadAction<any>) => {
      state[action.payload.id] = {
        isLoading: true,
        isLoaded: false,
        data: null,
      };
    },
    setUserTagData: (state: any, action: PayloadAction<any>) => {
      state[action.payload.id] = {
        isLoading: false,
        isLoaded: true,
        data: action.payload.data,
      };
    },
    setUpdatedUserProfileDetails: (state: any, action: PayloadAction<any>) => {
      state[action.payload._id] = {
        isLoaded: true,
        isLoading: false,
        data: action.payload,
      };
    },
  },
});

export const { setUserTagLoading, setUserTagData, setUpdatedUserProfileDetails } = userTagSlice.actions;

export default userTagSlice.reducer;
